import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ETipoCuestionario, ICuestionario, IEmpresa, IFiltroCuestionario, INotification } from '@core/models';
import { ISegmento } from '@core/models/Segmento.interface';
import { CuestionarioService } from '@core/services/cuestionario.service';
import { EstadoCompartidoService } from '@core/services/EstadoCompartido.service';
import { ToastComponent } from '@modules/utils/toast/toast.component';

@Component({
  selector: 'formulario-dinamico',
  templateUrl: './formulario-dinamico.component.html',
  styleUrls: ['./formulario-dinamico.component.scss']
})
export class FormularioDinamicoComponent implements OnInit {

  @Input() empresa:IEmpresa; 
  @Input() IdSegmento:number = 0; 
  @Input() colContainer?:number = 12;
  @Input() readOnly?:boolean = false;
  enumTipo = ETipoCuestionario
  @Output() formSubmit = new EventEmitter<UntypedFormGroup>();

  constructor(
    private fb:UntypedFormBuilder,
    private cuestionarioService: CuestionarioService,
    private toast: ToastComponent,
    private estadoCompartidoS: EstadoCompartidoService
  ) { }

  form:UntypedFormGroup;
  fields:ICuestionario[] = [];

  ngOnInit(): void {
    this.form = new UntypedFormGroup({});
    this.obtenerCuestionario();
    this.estadoCompartidoS.currentFormData.subscribe(
      data=>{
        this.form.patchValue(data);
      }
    )
  }

  validar(Param, idSegmento){
    
    
    
    if (Param.Obligatorio == 2) {
      
      // ESTE ES EL ID SELECCIONADO EN EL SELECT
      if (Param.Vinculados[0].opcion) {
        let ID1=   this.form.controls[Param.Vinculados[0].opcion?.IdCuestionario].value.Id;
        // busca el id seleccionado si esta en la lista de vinculados
        let Founded = Param.Vinculados.find(x => x.IdOpcion == ID1);
        
        
        if (!Founded) {
          return true
        }
        if (idSegmento !== Param.IdSegmento) {
          return true
          
        }
  
        if (Param.Vinculados[0].flg_visible!==1) {
         
          return true
        }
        
        
        if (Param.Vinculados[0].flg_obligatorio===1) {
          console.log(Param.IdTipoCuestionario);
          switch (Param.IdTipoCuestionario) {
            case this.enumTipo.TEXTO:
              // Puedes agregar validadores específicos para texto aquí
              this.form.controls[Param.Id].setValidators([Validators.required]);
              break;
            case this.enumTipo.RUT:
              // Puedes agregar validadores específicos para texto aquí
              this.form.controls[Param.Id].setValidators([Validators.required, Validators.pattern('[0-9]{1,10}-[Kk0-9]')]);
              
              break;
            case this.enumTipo.EMAIL:
              console.log('pasa');
              this.form.controls[Param.Id].setValidators([Validators.required,Validators.email]);
              break;
            case this.enumTipo.NUMERO:
              this.form.controls[Param.Id].setValidators([Validators.required,Validators.pattern('^[0-9]*$')] );
              
              break;
            case this.enumTipo.TELEFONO:
              this.form.controls[Param.Id].setValidators([Validators.required,Validators.pattern('^\\+56\\s9\\s[9876543]\\d{7}$')] );
              
              break;
            case this.enumTipo.OPCIONES:
              // Puedes agregar validadores específicos para opciones aquí
              this.form.controls[Param.Id].setValidators([Validators.required]);
              break;
            default:
              break;
          }

          // this.form.controls[Param.Id].setValidators(Validators.required);
        }
        else{
          this.form.controls[Param.Id].setValidators(null);
          switch (Param.IdTipoCuestionario) {
            case this.enumTipo.TEXTO:
              // Puedes agregar validadores específicos para texto aquí
              this.form.controls[Param.Id].setValidators(null);
              break;
            case this.enumTipo.RUT:
              // Puedes agregar validadores específicos para texto aquí
              this.form.controls[Param.Id].setValidators([ Validators.pattern('[0-9]{1,10}-[Kk0-9]')]);
              
              break;
            case this.enumTipo.EMAIL:
              console.log('pasa');
              this.form.controls[Param.Id].setValidators([Validators.email]);
              break;
            case this.enumTipo.NUMERO:
              this.form.controls[Param.Id].setValidators([Validators.pattern('^[0-9]*$')] );
              
              break;
            case this.enumTipo.TELEFONO:
              this.form.controls[Param.Id].setValidators([Validators.pattern('^\\+56\\s9\\s[9876543]\\d{7}$')] );
              
              break;
            case this.enumTipo.OPCIONES:
              // Puedes agregar validadores específicos para opciones aquí
              this.form.controls[Param.Id].setValidators(null);
              break;
            default:
              break;
          }
        }
        
        return false;
      }
      else{
        
        
        let ID1=   this.form.controls[Param.Vinculados[0].Id_CuestionarioPadre].value;
        if (ID1 ==='') {
          this.form.controls[Param.Vinculados[0].Id_CuestionarioPadre].setValue(false);
        }
        
        
        
        // busca el id seleccionado si esta en la lista de vinculados
        
        
        
        if (ID1===true) {
          this.form.controls[Param.Id].setValidators(null);
          this.form.controls[Param.Id].setValue('No registra dato');
          return true
        }
        if (idSegmento !== Param.IdSegmento) {
          return true
          
        }
  
        
        
        
        if (Param.Vinculados[0].flg_obligatorio===1 && ID1===false) {
         
          switch (Param.IdTipoCuestionario) {
            case this.enumTipo.TEXTO:
              // Puedes agregar validadores específicos para texto aquí
              this.form.controls[Param.Id].setValidators([Validators.required]);
              break;
            case this.enumTipo.RUT:
              // Puedes agregar validadores específicos para texto aquí
              this.form.controls[Param.Id].setValidators([Validators.required, Validators.pattern('[0-9]{1,10}-[Kk0-9]')]);
              
              break;
            case this.enumTipo.EMAIL:
              console.log('pasa');
              this.form.controls[Param.Id].setValidators([Validators.required,Validators.email]);
              break;
            case this.enumTipo.NUMERO:
              this.form.controls[Param.Id].setValidators([Validators.required,Validators.pattern('^[0-9]*$')] );
              
              break;
            case this.enumTipo.TELEFONO:
              this.form.controls[Param.Id].setValidators([Validators.required,Validators.pattern('^\\+56\\s9\\s[9876543]\\d{7}$')] );
              
              break;
            case this.enumTipo.OPCIONES:
              // Puedes agregar validadores específicos para opciones aquí
              this.form.controls[Param.Id].setValidators([Validators.required]);
              break;
            default:
              break;
          }
          
        }
        else{
          
          this.form.controls[Param.Id].setValidators(null);
          switch (Param.IdTipoCuestionario) {
            case this.enumTipo.TEXTO:
              // Puedes agregar validadores específicos para texto aquí
              this.form.controls[Param.Id].setValidators(null);
              break;
            case this.enumTipo.RUT:
              // Puedes agregar validadores específicos para texto aquí
              this.form.controls[Param.Id].setValidators([ Validators.pattern('[0-9]{1,10}-[Kk0-9]')]);
              
              break;
            case this.enumTipo.EMAIL:
              console.log('pasa');
              this.form.controls[Param.Id].setValidators([Validators.email]);
              break;
            case this.enumTipo.NUMERO:
              this.form.controls[Param.Id].setValidators([Validators.pattern('^[0-9]*$')] );
              
              break;
            case this.enumTipo.TELEFONO:
              this.form.controls[Param.Id].setValidators([Validators.pattern('^\\+56\\s9\\s[9876543]\\d{7}$')] );
              
              break;
            case this.enumTipo.OPCIONES:
              // Puedes agregar validadores específicos para opciones aquí
              this.form.controls[Param.Id].setValidators(null);
              break;
            default:
              break;
          }
        }
        
        
        return false;
      }

      
    }


    if (idSegmento !== Param.IdSegmento){
      return true;
    }
    return false;
  }

  obtenerCuestionario(){
    const filtro:IFiltroCuestionario = {
      IdTipoCuestionario: 0,
      IdSegmento: 0,
      IdEmpresa: this.empresa.Id,
      Habilitado: true
    }
    this.cuestionarioService.FiltroCuestionario(filtro).subscribe((data:INotification) => {
      
      this.fields = data.DataList.sort((a,b) => a.NroOrden - b.NroOrden);
      // if (this.IdSegmento > 0){
      //   this.fields = this.fields.filter(x => x.IdSegmento == this.IdSegmento);
      // }
        
      this.buildForm();
    });
    
  }


  mapFontFamily(value: string): string {
    switch (value) {
      case "1":
        return "Arial, sans-serif";
      case "2":
        return "Times New Roman, serif";
      case "3":
        return "Courier New, monospace";
      default:
        return "inherit";
    }
  }

  mapFontSizeTitle(value: string): string {
    switch (value) {
      case "1":
        return "30px";
      case "2":
        return "27px";
      case "3":
        return "20px";
      default:
        return "inherit";
    }
  }

  mapFontStyle(value: string): string {
    switch (value) {
      case "1":
        return "normal";
      case "2":
        return "italic";
      case "3":
        return "bold";
      case "4":
        return "italic bold";    
      default:
        return "inherit";
    }
  }
  getEstiloTitle(segmento: any) {

    console.log(segmento);
    const {fontDesc} = segmento;
    const fontTitle = fontDesc.split(';');

    return {
      'font-family': this.mapFontFamily(fontTitle[0]),
      'font-size': this.mapFontSizeTitle(fontTitle[1]),
      'font-style': this.mapFontStyle(fontTitle[2]).includes('italic') ? 'italic' : 'normal',
      'font-weight': this.mapFontStyle(fontTitle[2]).includes('bold') ? 'bold' : 'normal',
    };

  }


  buildForm() {
    let formGroup = {};
    this.fields.forEach(field => {
      let validators = [];
      if (this.IdSegmento == field.IdSegmento && field.Obligatorio==1 ) {
        validators.push(Validators.required);
        
      }
  
      // Aplica validadores según el tipo de campo
      switch (field.IdTipoCuestionario) {
        case this.enumTipo.TEXTO:
          // Puedes agregar validadores específicos para texto aquí
          break;
        case this.enumTipo.RUT:
          // Puedes agregar validadores específicos para texto aquí
          
          validators.push(Validators.pattern('[0-9]{1,10}-[Kk0-9]'));
          break;
        case this.enumTipo.EMAIL:
          validators.push(Validators.email);
          break;
        case this.enumTipo.NUMERO:
          validators.push(Validators.pattern('^[0-9]*$')); // Validador para números
          break;
        case this.enumTipo.TELEFONO:
          validators.push(Validators.pattern('^\\+56\\s9\\s[9876543]\\d{7}$')); // Validador para números telefónicos chilenos
          break;
        case this.enumTipo.OPCIONES:
          // Puedes agregar validadores específicos para opciones aquí
          break;
        default:
          break;
      }
      
      
      formGroup[field.Id] = ['', validators];// Agrega validaciones según sea necesario

    });
    this.form = this.fb.group(formGroup);
    

    this.estadoCompartidoS.currentFormData.subscribe(
      data=>{
        
        this.form.patchValue(data);
      }
    )
  }


  
  get formulario(){
    return this.form.controls;
  }


  inputError(field: any): boolean {
    
    return field.invalid && (field.dirty || field.touched);
  }

  onSubmit() {
    if (this.form.valid) {
      
      this.estadoCompartidoS.updateFormData(this.form.value);
   
      try {
        
        this.formSubmit.emit(this.form);
      } catch (error) {
        
      }

    }
    else{
      
      this.form.markAllAsTouched();
      this.toast.errorMessage('Formulario incompleto', 'Por favor, complete todos los campos obligatorios');
    }
  }
}
